import {
    terminateTaskPaneAddinCommand,
    getTaskPaneRunningInstance,
    TaskPaneType,
} from 'owa-addins-store';

export default function closeNonPersistentTaskPaneAddinCommand(
    hostItemIndex: string,
    targetWindow: Window
) {
    const runningTaskPane = getTaskPaneRunningInstance(
        TaskPaneType.NonPersistent,
        hostItemIndex,
        targetWindow
    );
    if (!runningTaskPane || (hostItemIndex && runningTaskPane.hostItemIndex !== hostItemIndex)) {
        return;
    }

    terminateTaskPaneAddinCommand(TaskPaneType.NonPersistent, hostItemIndex, targetWindow);
}
